import { render } from "./ShimmerRecommendations.vue?vue&type=template&id=48ff1c8b"
import script from "./ShimmerRecommendations.vue?vue&type=script&lang=js"
export * from "./ShimmerRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__